import React from 'react';

import { SavePhysicalAtonDialog } from './AtonPhysicalDialog';

export const CreatePhysicalAton = () => {
  return <SavePhysicalAtonDialog mutateType="create"></SavePhysicalAtonDialog>;
};
